import request from '@/utils/request'

// 通话记录
export function xunIPhoneRecord(data) {
  return request({
    url: '/admin/xuniPhoneRecord/list',
    method: 'post',
    data: data
  })
}
export function xunIPhoneList(data) {
  return request({
    url: '/admin/xuniPhone/list',
    method: 'post',
    data: data
  })
}
export function xunIPhoneSave(data) {
  return request({
    url: '/admin/xuniPhone/save',
    method: 'post',
    data: data
  })
}
export function xunIPhoneUpdate(data) {
  return request({
    url: '/admin/xuniPhone/update',
    method: 'post',
    data: data
  })
}
